enum ArchElementGeneric {
  SPRINGER = 'Springer',
  KEYSTONE = 'Keystone',
  VOUSSOIR = 'Voussoir',
  BRICK = 'Brick',
  BACKGROUND = 'Background',
}

export default ArchElementGeneric;
